<template>
  <fragment>
    <tr v-if="edit === false">
      <td>{{ index + 1 }}</td>
      <td>{{ row.name }}</td>
      <td>
        <font-awesome-icon icon="edit" size="2x" @click="edit = true"/>
      </td>
    </tr>
    <tr v-else-if="edit === true">
      <td>{{ index + 1 }}</td>
      <td>
        <input class="input" type="text" v-model="row.name">
      </td>
      <td>
        <div class="columns">
          <div class="column has-text-centered">
            <font-awesome-icon icon="save" size="2x" @click="updateEntry" />
          </div>
          <div class="column has-text-centered">
            <font-awesome-icon icon="window-close" size="2x" @click="edit = false" />
          </div>
        </div>
      </td>
    </tr>
  </fragment>
</template>

<script>
import UPDATE_EXPENSE_CATEGORY from '@/graphql/expense-categories/updateExpenseCategory.gql';

export default {
  name: 'ExpenseCategoriesRow',
  props: [
    'index',
    'initialRow',
  ],
  data() {
    return {
      row: this.initialRow,
      edit: false,
    };
  },
  methods: {
    updateEntry() {
      this.$apollo.mutate({
        mutation: UPDATE_EXPENSE_CATEGORY,
        variables: {
          id: this.row.id,
          name: this.row.name,
        },
      })
        .then((res) => {
          this.row = res.data.updateExpenseCategory;
          this.edit = false;
          this.$toasted.success('Expense category updated!');
        })
        .catch((error) => {
          this.$toasted.error(error);
        });
    },
  },
};
</script>

<style scoped>

</style>
